import { Injectable } from '@angular/core';

declare let bnmx_tms: any;

@Injectable({
  providedIn: 'root',
})
export class SendMetricService {
  constructor() {}

  sendInterationDetails(elementName: string) {
    console.log('Did click ' + elementName);
    try {
      if (
        typeof bnmx_tms != 'undefined' &&
        typeof bnmx_tms.interactionDetails != 'undefined'
      ) {
        bnmx_tms.interactionDetails(elementName);
      }
    } catch (err: any) {
      console.log(err.message);
    }
  }
  sendMovementsDetails(dropdownName: string, userSelection: string) {
    console.log('Did click ' + dropdownName + ', ' + userSelection);
    try {
      if (
        typeof bnmx_tms != 'undefined' &&
        typeof bnmx_tms.movementsDetails != 'undefined'
      ) {
        bnmx_tms.movementsDetails(dropdownName, userSelection);
      }
    } catch (err: any) {
      console.log(err.message);
    }
  }

  sendConsultaBanxico() {
    console.log('Did click consulta banxico');
    try {
      if (
        typeof bnmx_tms != 'undefined' &&
        typeof bnmx_tms.consultaBanxico != 'undefined'
      ) {
        bnmx_tms.consultaBanxico();
      }
    } catch (err: any) {
      console.log(err.message);
    }
  }
  sendDownloadCEP() {
    console.log('Did click download cep');
    try {
      if (
        typeof bnmx_tms != 'undefined' &&
        typeof bnmx_tms.downloadCEP != 'undefined'
      ) {
        bnmx_tms.downloadCEP();
      }
    } catch (err: any) {
      console.log(err.message);
    }
  }
  sendConsultaCEP() {
    console.log('Did click consulta cep');
    try {
      if (
        typeof bnmx_tms != 'undefined' &&
        typeof bnmx_tms.consultaCEP != 'undefined'
      ) {
        bnmx_tms.consultaCEP();
      }
    } catch (err: any) {
      console.log(err.message);
    }
  }
  sendRapidActions(textModule: string, textMessage: string) {
    console.log('Did click ' + textModule + ' - ' + textMessage);
    try {
      if (
        typeof bnmx_tms != 'undefined' &&
        typeof bnmx_tms.rapidActions != 'undefined'
      ) {
        bnmx_tms.rapidActions(textModule + ' - ' + textMessage);
      }
    } catch (err: any) {
      console.log(err.message);
    }
  }
}
